var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{},[(_vm.isRebuilding)?_c('RecoryIntro',{attrs:{"product":_vm.product}}):(_vm.isPhoto)?_c('PhotoIntro',{attrs:{"product":_vm.product}}):_c('CommonIntro',{attrs:{"product":_vm.product}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }